import { auth } from "firebase";
import React, { useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import BoxCard from "src/Components/BoxCard";
import CashBalance from "src/Components/CashBalance";
import Loader from "src/Components/Loader";
import StockBalance from "src/Components/StockBalance";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
`;

const LoadingContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = styled.div`
  background-color: white;
  padding: 1rem;
  position: sticky;
  top: 0;
  width: 100%;
  box-shadow: ${(props) => props.theme.boxShadow};
`;
const Name = styled.span`
  font-weight: 700;
  color: ${(props) => props.theme.darkBlueColor};
`;

const SmallGreyText = styled.p`
  font-size: 1.2rem;
  line-height: 1.2;
  font-weight: 400;
`;

const CTAWrapper = styled.div`
  width: 100%;
  display: grid;
  -ms-grid-columns: (minmax(0, 1fr)) [4];
  grid-template-columns: repeat(4, minmax(0, 1fr));
  @media (min-width: ${(props) => props.theme.maxWidth}) {
    -ms-grid-columns: (minmax(0, 1fr)) [6];
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
  grid-column-gap: 1rem;
  column-gap: 1rem;
  padding: 1rem 0px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  cursor: pointer;
  transition: 0.4s;
  :hover {
    border: solid 1px ${(props) => props.theme.primaryColor};
    color: ${(props) => props.theme.primaryColor};
    box-shadow: ${(props) => props.theme.boxShadow};
  }
  border: solid 1px ${(props) => props.theme.lightGreyColor};
  border-radius: 8px;
`;

const BoxIcon = styled.div``;

const BoxText = styled.p`
  font-weight: 600;
  text-align: center;
  margin-top: 0.125rem;
  font-size: 0.6rem;
  color: ${(props) => props.theme.darkGreyColor};
  line-height: 1.6;
`;

const Body = styled.div`
  padding: 1rem;
  width: 100%;
`;

const LinkText = styled.span`
  color: ${(props) => props.theme.primaryColor};
  :hover {
    color: ${(props) => props.theme.accentColor};
  }
`;

const CtaLinkText = styled.p`
  font-size: 0.8rem;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Title = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
`;

const DashboardGrid = styled.div`
  width: 100%;
  display: grid;
  -ms-grid-columns: (minmax(0, 1fr)) [1];
  grid-template-columns: repeat(1, minmax(0, 1fr));
  @media (min-width: 760px) {
    -ms-grid-columns: (minmax(0, 1fr)) [2];
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (min-width: ${(props) => props.theme.maxWidth}) {
    -ms-grid-columns: (minmax(0, 1fr)) [3];
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
  grid-column-gap: 1rem;
  column-gap: 1rem;
  padding: 1rem 0px;
`;

interface IProps extends RouteComponentProps<any> {
  loading: boolean;
  data: any;
  actions: any;
  isAdmin: boolean;
}
const HomePresenter: React.SFC<IProps> = ({
  loading,
  data,
  actions,
  isAdmin,
  history,
}) => {
  const [showCta, setShowCta] = useState(true);

  const toggleCta = () => {
    setShowCta(!showCta);
  };
  return loading || !data ? (
    <LoadingContainer>
      <div className=" w-full fixed h-full z-10 bg-white top-0 right-0 flex items-center justify-center">
        {isAdmin ? (
          <p className=" text-lg font-semibold">
            Welcome!
            <br />
            <span
              role="img"
              aria-label="Emoji"
              className=" cursor-pointer hover:underline text-base font-normal text-blue-400"
              onClick={() => {
                history.push("/admin");
              }}
            >
              🔥 Visit admin dashboard &rarr;
            </span>
            <br />
            <span
              role="img"
              aria-label="Emoji"
              onClick={() => {
                auth().signOut();
              }}
              className=" cursor-pointer hover:underline text-base font-normal text-red-400"
            >
              ❌ Sign out &rarr;
            </span>
          </p>
        ) : (
          <p>
            You don't have permission to be here.
            <br />
            <span
              role="img"
              aria-label="Emoji"
              className=" cursor-pointer hover:underline text-base font-normal text-red-400"
              onClick={() => {
                auth().signOut();
              }}
            >
              ❌ Sign out &rarr;
            </span>
          </p>
        )}
      </div>
      <Loader message="Retrieving data" />
    </LoadingContainer>
  ) : (
    <Container>
      <div className=" w-full fixed h-full z-10 bg-white top-0 right-0 flex items-center justify-center">
        {isAdmin ? (
          <p className=" text-lg font-semibold">
            Welcome!
            <br />
            <span
              role="img"
              aria-label="Emoji"
              className=" cursor-pointer hover:underline text-base font-normal text-blue-400"
              onClick={() => {
                history.push("/admin");
              }}
            >
              🔥 Visit admin dashboard &rarr;
            </span>
            <br />
            <span
              role="img"
              aria-label="Emoji"
              onClick={() => {
                auth().signOut();
              }}
              className=" cursor-pointer hover:underline text-base font-normal text-red-400"
            >
              ❌ Sign out &rarr;
            </span>
          </p>
        ) : (
          <p>
            You don't have permission to be here.
            <br />
            <span
              role="img"
              aria-label="Emoji"
              className=" cursor-pointer hover:underline text-base font-normal text-red-400"
              onClick={() => {
                auth().signOut();
              }}
            >
              ❌ Sign out &rarr;
            </span>
          </p>
        )}
      </div>
      <Header>
        <Row>
          <SmallGreyText>
            Welcome<Name> {data.users_by_pk.name}</Name>
          </SmallGreyText>
          <CtaLinkText onClick={toggleCta}>
            <LinkText>{showCta ? "Hide Actions" : "Show Actions"}</LinkText>
          </CtaLinkText>
        </Row>
        {showCta && (
          <CTAWrapper>
            {actions.map((ac, index) => (
              <Box key={index}>
                <BoxIcon>{ac.icon}</BoxIcon>
                <BoxText>{ac.name}</BoxText>
              </Box>
            ))}
          </CTAWrapper>
        )}
      </Header>
      <Body>
        <Title>My Assets</Title>
        <DashboardGrid>
          <BoxCard
            buttonLabel="View Details"
            buttonOnClick={""}
            buttonDisabled={false}
            showButton={true}
            title="Cash Wallet"
            subtitle={<CashBalance />}
            hints={[
              {
                text: data.users_by_pk.bankVerified
                  ? "Bank: Ok!"
                  : "Bank required!",
                color: data.users_by_pk.bankVerified ? "green" : "yellow",
              },
              {
                text: data.users_by_pk.ic_no ? "IC: Ok!" : "IC Required!",
                color: data.users_by_pk.ic_no ? "green" : "red",
              },
            ]}
          />
          <BoxCard
            buttonLabel="View Details"
            buttonOnClick={""}
            buttonDisabled={false}
            showButton={true}
            title="Stock Balance"
            subtitle={<StockBalance />}
          />
        </DashboardGrid>
        <Title>Sales and Bonus</Title>
      </Body>
    </Container>
  );
};
export default withRouter(HomePresenter);
